import { render, staticRenderFns } from "./BotaoFiscalizacaoOperacoes.vue?vue&type=template&id=36440402&lang=pug"
import script from "./BotaoFiscalizacaoOperacoes.vue?vue&type=script&lang=js"
export * from "./BotaoFiscalizacaoOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports